import { Controller } from "@hotwired/stimulus"

// Inline image viewer. Tapping a profile photo opens it in a full-screen
// overlay INSIDE the app instead of navigating to the raw image URL — the old
// <a target="_blank"> links kicked users out of the installed PWA.
//
// Also carries the (best-effort) anti-capture deterrents: no context menu, no
// drag, no long-press save. True screenshot blocking is not possible on the web.
//
//   <div data-controller="lightbox">
//     <img data-action="click->lightbox#open" data-lightbox-src-param="/big.jpg">
//     <div data-lightbox-target="overlay" hidden> <img data-lightbox-target="image"> </div>
//   </div>
export default class extends Controller {
  static targets = ["overlay", "image"]

  connect() {
    // Ensure the viewer starts closed. (The overlay uses inline display, so we
    // must toggle display directly — the `hidden` attribute is overridden by an
    // inline display value and would leave the overlay stuck open.)
    this.close()

    // Block right-click / long-press "save image" across this subtree.
    this._blockContext = (e) => {
      if (e.target && e.target.tagName === "IMG") e.preventDefault()
    }
    this.element.addEventListener("contextmenu", this._blockContext)
  }

  disconnect() {
    this.element.removeEventListener("contextmenu", this._blockContext)
    document.body.style.overflow = ""
  }

  open(event) {
    const src = event.params.src
    if (!src || !this.hasOverlayTarget) return
    if (this.hasImageTarget) this.imageTarget.src = src
    this.overlayTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
  }

  close() {
    if (this.hasOverlayTarget) this.overlayTarget.style.display = "none"
    if (this.hasImageTarget) this.imageTarget.removeAttribute("src")
    document.body.style.overflow = ""
  }

  // Close when the backdrop (not the image) is tapped.
  backdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }
}
